import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    component: Home,
    meta: { title: 'Home Page - Safetaxi' }
  },
  {
    path: '/descargas',
    meta: { title: 'About Page - Safetaxi' },
    component: () => import(/* webpackChunkName: "about" */ '../views/About.vue')
  },
  {
    path: '*',
    meta: { title: 'Error 404 - Safetaxi' },
    component: () => import(/* webpackChunkName: "about" */ '../views/error.vue')
  },
  {
    path: "/soporte",
    name: "Soporte",
    meta: { title: "Soporte - Safetaxi"},
    component: () => import('../views/Soporte.vue')
  },
  {
    path: '/feedback',
    name: 'Feedback',
    meta: { title: 'Feedback - Safetaxi' },
    component: () => import('../views/Comentarios.vue')
  },
  {
    path: '/privacidad',
    name: 'Privacidad',
    meta: { title: 'Aviso de Privacidad - Safetaxi' },
    component: () => import('../views/Privacidad.vue')
  },
  {
    path: '/privacidadApp',
    name: 'PrivacidadApp',
    meta: { title: 'Aviso de Privacidad - Safetaxi' },
    component: () => import('../views/PrivacidadApp.vue')
  },

]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

router.beforeEach((to, from, next) => {
    document.title = to.meta.title
    next()
})

export default router
